<modal-container #modal [headerTitle]="''" [headerIconClass]="'fa-info-circle'">
  <ng-container class="modal-body-content">
    <strong>{{'purchaseOrder.qrcode.instructions' | translate}}</strong>
    <p [ngClass]="{ 'text-center': true }">
      <img
        [src]="qrBase64"
        alt=""
        *ngIf="qrBase64 && qrBase64.length > 0"
        class="qr-code"
      />
    </p>
  </ng-container>
</modal-container>
